import Lottie from 'react-lottie'
import constants from '../../../constants'
import Text from '../../../components/Text'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import * as actions from '../../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import PageHeader from '../../../components/PageHeader'
import anayaCareImgUrls, {
  coinsCount,
  document_types,
} from '../../../constants/anaya-constants'
import DocumentView from '../Components/UploadDocuments/DocumentView'
import {
  supportProgramStatus,
  supportProgramTypes,
} from '../../../constants/support-programs'
import * as coinsAnimationData from '../../../assets/animations/coins-animate.json'
import useFetchDocuments from '../hooks/useFetchDocuments'
import DocumentStatusBanner from '../Components/DocumentStatusBanner'
import { isInApp } from '../../../utils/helpers/common'

const DocumentStatus = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const inApp = isInApp()
  const [uploadedDocuments, setUploadedDocuments] = useState([])
  const supportProgram = supportProgramTypes[constants.CARE_PROGRAM_TYPE.ANAYA]

  const { patientDetails } = useSelector((state) => state.auth)

  const { documents } = useFetchDocuments()

  const coinsAnimationOptions = {
    loop: true,
    autoplay: true,
    animationData: coinsAnimationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  useEffect(() => {
    fetchDocuments()
  }, [])

  const fetchDocuments = () => {
    const payload = {
      patient_id: patientDetails?.data?.patient_id,
      report_type: supportProgram.upload_report_type,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  const onUploadSuccess = () => {
    const qp = `support_program_type=${constants.CARE_PROGRAM_TYPE.ANAYA}`
    navigate(`/care-plans/anaya-care/home?${qp}`, { replace: true })
  }

  const hasRejectedDocuments = documents?.data?.data?.some(
    (record) =>
      record.record_meta_info?.report_status === constants.REJECTED_STATUS,
  )

  return (
    <div className="min-h-screen bg-[#F2F2F2] pb-4 max-w-md mx-auto">
      {inApp ? null : (
        <PageHeader
          borderBottom={false}
          bg="bg-[#ECE2F7]"
          handleonClickBack={onUploadSuccess}
        />
      )}
      {/* Header */}
      <div className="document-status-header-bg">
        <div className="flex items-center">
          <img
            src={anayaCareImgUrls.nurseImg}
            alt="Anaya Care"
            className="w-[150px] max-w-[150px] h-full rounded-xl object-cover mt-6"
          />
          <div className="px-4">
            <Text
              tag="p"
              variant="title"
              size="large"
              className="text-[#1F2933]"
            >
              Care Specialist is preparing your treatment journey
            </Text>
            <Text
              tag="p"
              variant="title"
              size="small"
              className="text-[#3D4854]"
            >
              This will take upto 24 hours
            </Text>
            <Text
              tag="p"
              variant="body"
              size="small"
              className="text-[#3D4854]"
            >
              We’ll reach out to you on WhatsApp once your details are approved.
              Thank you for your patience.
            </Text>
          </div>
        </div>
      </div>

      {/* Sub Header */}
      <DocumentStatusBanner
        hasRejectedDocuments={hasRejectedDocuments}
        coinsCount={coinsCount}
        coinsAnimationOptions={coinsAnimationOptions}
      />
      {/* Document Status */}
      <div className="pt-8 px-4">
        <div className="flex flex-col gap-4 pb-4">
          {document_types.map((documentTypes) => {
            const document =
              documents?.data?.data?.find(
                (i) => i.title === documentTypes.document_title,
              ) ?? null

            const documentStatus =
              document?.record_meta_info?.report_status ===
              supportProgramStatus.DOCUMENT_REVIEW_STATUS.REJECTED
                ? 'rejected'
                : document?.record_meta_info?.report_status ===
                    supportProgramStatus.DOCUMENT_REVIEW_STATUS.UNDER_REVIEW
                  ? 'under_review'
                  : 'pending'

            return (
              <DocumentView
                key={documentTypes.document_title}
                document={document}
                documentType={documentTypes.document_type}
                uploadReportType={supportProgram.upload_report_type}
                documentStatus={documentStatus}
                onUploadSuccess={onUploadSuccess}
                documentConstObj={documentTypes}
                setUploadedDocuments={setUploadedDocuments}
                // afterCompletion={() => onUploadSuccess('prescription')}
                // setIsLoaderVisible={setLoader}
                // onDeletePress={() => onDeletePress('prescription')}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default DocumentStatus
